"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
jQuery(document).ready(function ($) {
  // User login
  var divVisible = false;
  var $myDiv = $('#menu-customer-login');
  $('.site-login').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (divVisible) {
      $myDiv.hide();
      divVisible = false;
    } else {
      $myDiv.show();
      divVisible = true;
    }
  });

  // Hide login popup when you click outside of it
  $(document).on('click', function () {
    if (divVisible) {
      $myDiv.hide();
      divVisible = false;
    }
  });

  // Prevents event from bubbling up to the document
  $myDiv.click(function (e) {
    e.stopPropagation();
    $(this).hide();
  });

  // Collapse all the accordion by default
  $('.et_pb_module.et_pb_accordion .et_pb_accordion_item.et_pb_toggle_open').addClass('et_pb_toggle_close').removeClass('et_pb_toggle_open');

  // Change the favicon for the commercial pages only
  switch (true) {
    case $('body').hasClass('JE'):
      $('link[rel="icon"]').attr('href', 'https://assets.justenergy.com/wp-content/uploads/2020/09/cropped-just-energy-logo-192x192.png');
      break;
    case $('body').hasClass('AE'):
      $('link[rel="icon"]').attr('href', 'https://assets.amigoenergy.com/wp-content/uploads/2022/04/favicon-AE.png');
      break;
    case $('body').hasClass('TE'):
      $('link[rel="icon"]').attr('href', 'https://assets.taraenergy.com/wp-content/uploads/2020/10/tara-star-150x150.png');
      break;
    default:
    // Display the default Hudson favicon for the rest of the Hudson site
  }
});

// ES Navigation popup
document.addEventListener('DOMContentLoaded', function () {
  var _document$querySelect;
  var selectors = ['.translatepress-es_MX #menu-utility-nav li ul.sub-menu li a[href="https://account.hudsonenergy.net/"]', '.translatepress-es_MX a.login'];
  var popupLinkSelector = selectors.find(function (selector) {
    return document.querySelector(selector);
  });
  var accountPortal = document.getElementById('account-portal');
  var innerContentElements = document.getElementsByClassName('et_builder_inner_content');

  // Show account portal on popup link click
  (_document$querySelect = document.querySelector(popupLinkSelector)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.addEventListener('click', function (e) {
    e.preventDefault();
    accountPortal === null || accountPortal === void 0 ? void 0 : accountPortal.style.setProperty('display', 'block');
    var _iterator = _createForOfIteratorHelper(innerContentElements),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var el = _step.value;
        el.style.setProperty('z-index', '1');
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });

  // Hide account portal when clicking outside .et_pb_row
  document.addEventListener('click', function (e) {
    var clickedInsideRow = e.target.closest('.et_pb_row');
    if (!clickedInsideRow) {
      accountPortal === null || accountPortal === void 0 ? void 0 : accountPortal.style.setProperty('display', 'none');
      innerContentElements[0].style.setProperty('z-index', '2');
    }
  });
  document.querySelectorAll('.translatepress-es_MX a.login').forEach(function (loginLink) {
    loginLink.addEventListener('click', function (event) {
      event.preventDefault(); // Prevent the default behavior if needed

      var clickedHref = this.getAttribute('href'); // Get href of clicked login link

      // Find the .green-button link and update its href
      var greenButtonLink = document.querySelector('.green-button a');
      if (greenButtonLink) {
        greenButtonLink.setAttribute('href', clickedHref);
      }

      // Optionally, proceed with the original link (if needed)
      // window.location.href = clickedHref;
    });
  });
});

// Dynamically display current year in the footer
var yearElement = document.querySelector('.year');
var currentYear = new Date().getFullYear();
yearElement.textContent = currentYear;

// Check if the browser is Internet Explorer 11 or below
function isIE() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');
  var trident = ua.indexOf('Trident/');
  return msie > -1 || trident > -1;
}

// Check if the redirection cookie exists
function hasRedirectionCookie() {
  return document.cookie.indexOf('ieRedirected=true') > -1;
}

// Set the redirection cookie with a 24-hour expiration
function setRedirectionCookie() {
  var expirationDate = new Date();
  expirationDate.setTime(expirationDate.getTime() + 24 * 60 * 60 * 1000); // 24 hours in milliseconds
  var expires = "expires=" + expirationDate.toUTCString();
  document.cookie = 'ieRedirected=true; ' + expires + '; path=/';
}

// Redirect if the browser is Internet Explorer 11 or below and the cookie doesn't exist
if (isIE() && !hasRedirectionCookie()) {
  setRedirectionCookie();
  window.location.href = '/update-browser/'; // Replace with the URL of the page you want to redirect to
}